const mediaData = [
  { id: 1, src: '/images/media/img1.jpg', caption: 'Media Coverage 1' },
  { id: 2, src: '/images/media/img2.jpg', caption: 'Media Coverage 2' },
  { id: 3, src: '/images/media/img3.jpg', caption: 'Media Coverage 3' },
  { id: 4, src: '/images/media/img4.png', caption: 'Media Coverage 4' },
  { id: 5, src: '/images/media/img5.png', caption: 'Media Coverage 5' },
  { id: 6, src: '/images/media/img6.jpg', caption: 'Media Coverage 6' },
  { id: 7, src: '/images/media/img7.jpg', caption: 'Media Coverage 7' },
  { id: 8, src: '/images/media/img8.jpg', caption: 'Media Coverage 8' },
]
export default mediaData
